import {
  LOAD_QUOTE,
  ACCEPT_QUOTE,
  SEND_QUOTE,
  SEND_PBG_QUOTE,
  REJECT_AND_CREATE_QUOTE,
  COMPLETE_REPORT,
  DELETE_QUOTE,
  OPEN_MODAL,
  PBG_REQUEST,
  ASSURE_QUALITY,
  ASSIGN_QUOTE
} from '@/vuex/types'
import Api from '@/vuex/api'

const api = new Api()

const state = {
  quote: {
    uuid: '',
    reference: '',
    address: '',
    actualCost: '',
    QuotePropertyPhoto: []
  }
}

const getters = {
  loadedQuote ({ quote }) {
    return { ...quote }
  }
}

const mutations = {
  [LOAD_QUOTE] (state, payload) {
    state.quote = { ...state.quote, ...payload.quote }
  }
}

const actions = {
  async [LOAD_QUOTE] (context, quoteUuid) {
    let { quote } = await api.getQuote(quoteUuid)
    context.commit(LOAD_QUOTE, { quote: {...quote} })
  },
  [PBG_REQUEST] (context, quoteUuid) {
    let pBGModal = {
      permalink: 'pBGRequest',
      options: {
        title: 'Submit Price Beat Guarantee Request',
        actionLabel: 'Submit'
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, pBGModal)
  },
  [ACCEPT_QUOTE] (context, quoteUuid) {
    let acceptQuoteModal = {
      permalink: 'acceptQuote',
      options: {
        title: 'Accept Quote',
        actionLabel: 'Accept'
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, acceptQuoteModal)
  },
  [SEND_QUOTE] (context, QuoteUuid) {
    let sendModal = {
      permalink: 'sendQuote',
      options: {
        title: 'Send Quote',
        actionLabel: 'Send'
      },
      params: {
        QuoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendModal)
  },
  [SEND_PBG_QUOTE] (context, QuoteUuid) {
    let sendPBGrModal = {
      permalink: 'sendPBGrQuote',
      options: {
        title: 'Send Price Beat Guarantee Quote',
        actionLabel: 'Send'
      },
      params: {
        QuoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendPBGrModal)
  },
  [REJECT_AND_CREATE_QUOTE] (context, quoteUuid) {
    let rejectModal = {
      permalink: 'newQuote',
      options: {
        title: 'Reject And Create Quote',
        actionLabel: 'Reject And Create'
      },
      params: {
        quoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, rejectModal)
  },
  async [ASSURE_QUALITY] (context, QuoteUuid) {
    let assuranceModal = {
      permalink: 'assureQuality',
      options: {
        title: 'Assure Quality',
        actionLabel: 'Proceed'
      },
      params: {
        QuoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, assuranceModal)
  },
  async [ASSIGN_QUOTE] (context, QuoteUuid) {
    let assignQuoteModal = {
      permalink: 'assignQuote',
      options: {
        title: 'Assign Quote',
        actionLabel: 'Assign'
      },
      params: {
        QuoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, assignQuoteModal)
  },
  [DELETE_QUOTE] (context, QuoteUuid) {
    let modal = {
      permalink: 'deleteQuote',
      options: {
        title: 'Delete Quote',
        actionLabel: 'Delete'
      },
      params: {
        QuoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, modal)
  },
  async [COMPLETE_REPORT] (context, QuoteUuid) {
    let completeModal = {
      permalink: 'completeReport',
      options: {
        title: 'Complete Report',
        actionLabel: 'Proceed'
      },
      params: {
        QuoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, completeModal)
  }
}

export default {
  actions,
  getters,
  mutations,
  state
}




// WEBPACK FOOTER //
// ./src/vuex/modules/quotes.js